export enum EventTypes {
	UPDATE = 'UPDATE',
	UPDATE_SHARED_FILTERS = 'UPDATE_SHARED_FILTERS', // Used when global input apps need to manage shared filters and thus when a selection is made, the selection needs to be synced with other GI apps.
	GLOBAL_SEARCH_CHANGE = 'ksys-global-search-change', // Used when a search is fired from the Global Search app
	GLOBAL_INPUTS_CHANGE = 'ksys-global-inputs-change', // Used when the input values change on a Global Inputs app
	APP_INITIALIZED = 'ksys-app-initialized', // Used when an app is initialized
	PAGINATION_CHANGE = 'ksys-on-pagination-change', // Used when one of the pagination buttons has been clicked or one of the pagination dropdowns' value has changed
	UPDATE_PAGINATION = 'ksys-update-pagination', // Used when an app linked to the pagination app has updated
	CHANGE_ATTESTATION = 'ksys-change-attestation', // Used when an app requests a change attestation dialog (Attestation Wizard App) to show
	APPLY_FILTERS = 'ksys-apply-filters', // Used when the filter values are applied on a Global Inputs app
}


// WEBPACK FOOTER //
// ./src/models/eventManager/EventTypes.ts